module.exports = __webpack_public_path__ + "static/media/Building.23a8a3ec.svg";